import trainEvents from '../config/train-events';

export default function TrainsClearFiltersBaseController(
    $scope,
    $rootScope,
    trainsFactory
) {
    'ngInject';

            /**
             * Indicate carousel filtering
             */
            $scope.carouselFilterApplied = false;

            let clearFiltersClicked = false;

            $scope.$on(trainEvents.APPLY_FILTERS, function() {
                if (!clearFiltersClicked) {
                    $scope.carouselFilterApplied = true;
                }
                clearFiltersClicked = false;
            });

            /**
             * Reset filters to show all airlines
             */
            $scope.showAllAirlines = function() {
                trainsFactory.params.Filters = {QuantityOfStops: 3};
                trainsFactory.params.SegmentFilterData = [];

                $scope.carouselFilterApplied = false;
                $rootScope.$broadcast(trainEvents.CLEAR_SEGMENTS);

                $scope.clearFilters();
            };

            /**
             * Remove all filtering rules
             */
            $scope.clearFilters = function() {
                clearFiltersClicked = true;
                $rootScope.$broadcast(trainEvents.CLEAR_FILTERS);
            };
}



// WEBPACK FOOTER //
// ./src/app/modules/trains-base/controllers/trains-clear-filters-base-controller.js